import React, { FC } from 'react';

interface Props {
  src: string;
  alt?: string;
}

const PlatformImage: FC<Props> = ({ src, alt }) => {
  return (
    <img
      className="platform-logo-x"
      style={{ height: '35px', width: '80px', objectFit: 'contain' }}
      src={src}
      alt={alt || ''}
    />
  );
};

export default PlatformImage;
